/**
 * Límites de slots visibles en la barra de `Filters` por ancho de viewport.
 * En pantallas medianas y pequeñas no se muestran slots en barra; todo va al slideout «All filters».
 *
 * Layout toolbar (`filtersTokens.js`): compact `justify-start`; desktop `justify-between`.
 * - `≥ xl` (1280px): toolbar completo — slots, Clear Filters, sort, view y actions.
 * - `< xl`: solo SearchInput + botón «All filters».
 *
 * | Viewport              | min-width | Slots en barra |
 * |-----------------------|-----------|----------------|
 * | Desktop (xl+)         | 1280px    | hasta 4        |
 * | Mediana / pequeña     | < 1280px  | 0              |
 *
 * Search width: 88px solo en celulares (`< sm`, 640px); 225px desde `sm+`.
 */

/** Tailwind `sm` — celulares muy pequeños por debajo de este ancho usan search 88px. */
export const FILTERS_SEARCH_COMPACT_MAX_WIDTH = 639;

export const FILTERS_SEARCH_WIDTH = {
  phone: 88,
  default: 225,
};

export const FILTERS_BAR_SLOT_LIMITS = {
  desktop: 4,
  compact: 0,
};

/** min-width en px — alineado con Tailwind xl (1280). */
export const FILTERS_BAR_BREAKPOINTS = {
  desktop: 1280,
};

/**
 * @param {number} width — `window.innerWidth` o ancho del contenedor
 * @returns {number} 0–4
 */
export function getFiltersBarSlotLimitForWidth(width) {
  if (width >= FILTERS_BAR_BREAKPOINTS.desktop) return FILTERS_BAR_SLOT_LIMITS.desktop;
  return FILTERS_BAR_SLOT_LIMITS.compact;
}
